// Intro
import introMove from './steps/intro-1-move.zh_CN.gif';
import introSay from './steps/intro-2-say.zh_CN.gif';
import introGreenFlag from './steps/intro-3-green-flag.zh_CN.gif';

// Text to Speech
import speechAddExtension from './steps/speech-add-extension.zh_CN.gif';
import speechSaySomething from './steps/speech-say-something.zh_CN.png';
import speechSetVoice from './steps/speech-set-voice.zh_CN.png';
import speechMoveAround from './steps/speech-move-around.zh_CN.png';
import speechAddBackdrop from './steps/pick-backdrop.LTR.gif';
import speechAddSprite from './steps/speech-add-sprite.LTR.gif';
import speechSong from './steps/speech-song.zh_CN.png';
import speechChangeColor from './steps/speech-change-color.zh_CN.png';
import speechSpin from './steps/speech-spin.zh_CN.png';
import speechGrowShrink from './steps/speech-grow-shrink.zh_CN.png';

// Cartoon Network
import cnShowCharacter from './steps/cn-show-character.LTR.gif';
import cnSay from './steps/cn-say.zh_CN.png';
import cnGlide from './steps/cn-glide.zh_CN.png';
import cnPickSprite from './steps/cn-pick-sprite.LTR.gif';
import cnCollect from './steps/cn-collect.zh_CN.png';
import cnVariable from './steps/add-variable.zh_CN.gif';
import cnScore from './steps/cn-score.zh_CN.png';
import cnBackdrop from './steps/cn-backdrop.zh_CN.png';

// Add sprite
import addSprite from './steps/add-sprite.LTR.gif';

// Animate a name
import namePickLetter from './steps/name-pick-letter.LTR.gif';
import namePlaySound from './steps/name-play-sound.zh_CN.png';
import namePickLetter2 from './steps/name-pick-letter2.LTR.gif';
import nameChangeColor from './steps/name-change-color.zh_CN.png';
import nameSpin from './steps/name-spin.zh_CN.png';
import nameGrow from './steps/name-grow.zh_CN.png';

// Make Music
import musicPickInstrument from './steps/music-pick-instrument.LTR.gif';
import musicPlaySound from './steps/music-play-sound.zh_CN.png';
import musicMakeSong from './steps/music-make-song.zh_CN.png';
import musicMakeBeat from './steps/music-make-beat.zh_CN.png';
import musicMakeBeatbox from './steps/music-make-beatbox.zh_CN.png';

// Chase-Game
import chaseGameAddBackdrop from './steps/chase-game-add-backdrop.LTR.gif';
import chaseGameAddSprite1 from './steps/chase-game-add-sprite1.LTR.gif';
import chaseGameRightLeft from './steps/chase-game-right-left.zh_CN.png';
import chaseGameUpDown from './steps/chase-game-up-down.zh_CN.png';
import chaseGameAddSprite2 from './steps/chase-game-add-sprite2.LTR.gif';
import chaseGameMoveRandomly from './steps/chase-game-move-randomly.zh_CN.png';
import chaseGamePlaySound from './steps/chase-game-play-sound.zh_CN.png';
import chaseGameAddVariable from './steps/add-variable.zh_CN.gif';
import chaseGameChangeScore from './steps/chase-game-change-score.zh_CN.png';

// Clicker-Game (Pop Game)
import popGamePickSprite from './steps/pop-game-pick-sprite.LTR.gif';
import popGamePlaySound from './steps/pop-game-play-sound.zh_CN.png';
import popGameAddScore from './steps/add-variable.zh_CN.gif';
import popGameChangeScore from './steps/pop-game-change-score.zh_CN.png';
import popGameRandomPosition from './steps/pop-game-random-position.zh_CN.png';
import popGameChangeColor from './steps/pop-game-change-color.zh_CN.png';
import popGameResetScore from './steps/pop-game-reset-score.zh_CN.png';

// Animate A Character
import animateCharPickBackdrop from './steps/pick-backdrop.LTR.gif';
import animateCharPickSprite from './steps/animate-char-pick-sprite.LTR.gif';
import animateCharSaySomething from './steps/animate-char-say-something.zh_CN.png';
import animateCharAddSound from './steps/animate-char-add-sound.zh_CN.png';
import animateCharTalk from './steps/animate-char-talk.zh_CN.png';
import animateCharMove from './steps/animate-char-move.zh_CN.png';
import animateCharJump from './steps/animate-char-jump.zh_CN.png';
import animateCharChangeColor from './steps/animate-char-change-color.zh_CN.png';

// Tell A Story
import storyPickBackdrop from './steps/story-pick-backdrop.LTR.gif';
import storyPickSprite from './steps/story-pick-sprite.LTR.gif';
import storySaySomething from './steps/story-say-something.zh_CN.png';
import storyPickSprite2 from './steps/story-pick-sprite2.LTR.gif';
import storyFlip from './steps/story-flip.zh_CN.gif';
import storyConversation from './steps/story-conversation.zh_CN.png';
import storyPickBackdrop2 from './steps/story-pick-backdrop2.LTR.gif';
import storySwitchBackdrop from './steps/story-switch-backdrop.zh_CN.png';
import storyHideCharacter from './steps/story-hide-character.zh_CN.png';
import storyShowCharacter from './steps/story-show-character.zh_CN.png';

// Video Sensing
import videoAddExtension from './steps/video-add-extension.zh_CN.gif';
import videoPet from './steps/video-pet.zh_CN.png';
import videoAnimate from './steps/video-animate.zh_CN.png';
import videoPop from './steps/video-pop.zh_CN.png';

// Make it Fly
import flyChooseBackdrop from './steps/fly-choose-backdrop.LTR.gif';
import flyChooseCharacter from './steps/fly-choose-character.LTR.png';
import flySaySomething from './steps/fly-say-something.zh_CN.png';
import flyMoveArrows from './steps/fly-make-interactive.zh_CN.png';
import flyChooseObject from './steps/fly-object-to-collect.LTR.png';
import flyFlyingObject from './steps/fly-flying-heart.zh_CN.png';
import flySelectFlyingSprite from './steps/fly-select-flyer.LTR.png';
import flyAddScore from './steps/add-variable.zh_CN.gif';
import flyKeepScore from './steps/fly-keep-score.zh_CN.png';
import flyAddScenery from './steps/fly-choose-scenery.LTR.gif';
import flyMoveScenery from './steps/fly-move-scenery.zh_CN.png';
import flySwitchLooks from './steps/fly-switch-costume.zh_CN.png';

// Pong
import pongAddBackdrop from './steps/pong-add-backdrop.LTR.png';
import pongAddBallSprite from './steps/pong-add-ball-sprite.LTR.png';
import pongBounceAround from './steps/pong-bounce-around.zh_CN.png';
import pongAddPaddle from './steps/pong-add-a-paddle.LTR.gif';
import pongMoveThePaddle from './steps/pong-move-the-paddle.zh_CN.png';
import pongSelectBallSprite from './steps/pong-select-ball.LTR.png';
import pongAddMoreCodeToBall from './steps/pong-add-code-to-ball.zh_CN.png';
import pongAddAScore from './steps/add-variable.zh_CN.gif';
import pongChooseScoreFromMenu from './steps/pong-choose-score.zh_CN.png';
import pongInsertChangeScoreBlock from './steps/pong-insert-change-score.zh_CN.png';
import pongResetScore from './steps/pong-reset-score.zh_CN.png';
import pongAddLineSprite from './steps/pong-add-line.LTR.gif';
import pongGameOver from './steps/pong-game-over.zh_CN.png';

// Imagine a World
import imagineTypeWhatYouWant from './steps/imagine-type-what-you-want.zh_CN.png';
import imagineClickGreenFlag from './steps/imagine-click-green-flag.zh_CN.png';
import imagineChooseBackdrop from './steps/imagine-choose-backdrop.LTR.png';
import imagineChooseSprite from './steps/imagine-choose-any-sprite.LTR.png';
import imagineFlyAround from './steps/imagine-fly-around.zh_CN.png';
import imagineChooseAnotherSprite from './steps/imagine-choose-another-sprite.LTR.png';
import imagineLeftRight from './steps/imagine-left-right.zh_CN.png';
import imagineUpDown from './steps/imagine-up-down.zh_CN.png';
import imagineChangeCostumes from './steps/imagine-change-costumes.zh_CN.png';
import imagineGlideToPoint from './steps/imagine-glide-to-point.zh_CN.png';
import imagineGrowShrink from './steps/imagine-grow-shrink.zh_CN.png';
import imagineChooseAnotherBackdrop from './steps/imagine-choose-another-backdrop.LTR.png';
import imagineSwitchBackdrops from './steps/imagine-switch-backdrops.zh_CN.png';
import imagineRecordASound from './steps/imagine-record-a-sound.zh_CN.gif';
import imagineChooseSound from './steps/imagine-choose-sound.zh_CN.png';

// Add a Backdrop
import addBackdrop from './steps/add-backdrop.LTR.png';

// Add Effects
import addEffects from './steps/add-effects.zh_CN.png';

// Hide and Show
import hideAndShow from './steps/hide-show.zh_CN.png';

// Switch Costumes
import switchCostumes from './steps/switch-costumes.zh_CN.png';

// Change Size
import changeSize from './steps/change-size.zh_CN.png';

// Spin
import spinTurn from './steps/spin-turn.zh_CN.png';
import spinPointInDirection from './steps/spin-point-in-direction.zh_CN.png';

// Record a Sound
import recordASoundSoundsTab from './steps/record-a-sound-sounds-tab.zh_CN.png';
import recordASoundClickRecord from './steps/record-a-sound-click-record.zh_CN.png';
import recordASoundPressRecordButton from './steps/record-a-sound-press-record-button.zh_CN.png';
import recordASoundChooseSound from './steps/record-a-sound-choose-sound.zh_CN.png';
import recordASoundPlayYourSound from './steps/record-a-sound-play-your-sound.zh_CN.png';

// Use Arrow Keys
import moveArrowKeysLeftRight from './steps/move-arrow-keys-left-right.zh_CN.png';
import moveArrowKeysUpDown from './steps/move-arrow-keys-up-down.zh_CN.png';

// Glide Around
import glideAroundBackAndForth from './steps/glide-around-back-and-forth.zh_CN.png';
import glideAroundPoint from './steps/glide-around-point.zh_CN.png';

// Code a Cartoon
import codeCartoonSaySomething from './steps/code-cartoon-01-say-something.zh_CN.png';
import codeCartoonAnimate from './steps/code-cartoon-02-animate.zh_CN.png';
import codeCartoonSelectDifferentCharacter from './steps/code-cartoon-03-select-different-character.LTR.png';
import codeCartoonUseMinusSign from './steps/code-cartoon-04-use-minus-sign.zh_CN.png';
import codeCartoonGrowShrink from './steps/code-cartoon-05-grow-shrink.zh_CN.png';
import codeCartoonSelectDifferentCharacter2 from './steps/code-cartoon-06-select-another-different-character.LTR.png';
import codeCartoonJump from './steps/code-cartoon-07-jump.zh_CN.png';
import codeCartoonChangeScenes from './steps/code-cartoon-08-change-scenes.zh_CN.png';
import codeCartoonGlideAround from './steps/code-cartoon-09-glide-around.zh_CN.png';
import codeCartoonChangeCostumes from './steps/code-cartoon-10-change-costumes.zh_CN.png';
import codeCartoonChooseMoreCharacters from './steps/code-cartoon-11-choose-more-characters.LTR.png';

// Talking Tales
import talesAddExtension from './steps/speech-add-extension.zh_CN.gif';
import talesChooseSprite from './steps/talking-2-choose-sprite.LTR.png';
import talesSaySomething from './steps/talking-3-say-something.zh_CN.png';
import talesChooseBackdrop from './steps/talking-4-choose-backdrop.LTR.png';
import talesSwitchBackdrop from './steps/talking-5-switch-backdrop.zh_CN.png';
import talesChooseAnotherSprite from './steps/talking-6-choose-another-sprite.LTR.png';
import talesMoveAround from './steps/talking-7-move-around.zh_CN.png';
import talesChooseAnotherBackdrop from './steps/talking-8-choose-another-backdrop.LTR.png';
import talesAnimateTalking from './steps/talking-9-animate.zh_CN.png';
import talesChooseThirdBackdrop from './steps/talking-10-choose-third-backdrop.LTR.png';
import talesChooseSound from './steps/talking-11-choose-sound.zh_CN.gif';
import talesDanceMoves from './steps/talking-12-dance-moves.zh_CN.png';
import talesAskAnswer from './steps/talking-13-ask-and-answer.zh_CN.png';

const zhCnImages = {
    // Intro
    introMove: introMove,
    introSay: introSay,
    introGreenFlag: introGreenFlag,

    // Text to Speech
    speechAddExtension: speechAddExtension,
    speechSaySomething: speechSaySomething,
    speechSetVoice: speechSetVoice,
    speechMoveAround: speechMoveAround,
    speechAddBackdrop: speechAddBackdrop,
    speechAddSprite: speechAddSprite,
    speechSong: speechSong,
    speechChangeColor: speechChangeColor,
    speechSpin: speechSpin,
    speechGrowShrink: speechGrowShrink,

    // Cartoon Network
    cnShowCharacter: cnShowCharacter,
    cnSay: cnSay,
    cnGlide: cnGlide,
    cnPickSprite: cnPickSprite,
    cnCollect: cnCollect,
    cnVariable: cnVariable,
    cnScore: cnScore,
    cnBackdrop: cnBackdrop,

    // Add sprite
    addSprite: addSprite,

    // Animate a name
    namePickLetter: namePickLetter,
    namePlaySound: namePlaySound,
    namePickLetter2: namePickLetter2,
    nameChangeColor: nameChangeColor,
    nameSpin: nameSpin,
    nameGrow: nameGrow,

    // Make-Music
    musicPickInstrument: musicPickInstrument,
    musicPlaySound: musicPlaySound,
    musicMakeSong: musicMakeSong,
    musicMakeBeat: musicMakeBeat,
    musicMakeBeatbox: musicMakeBeatbox,

    // Chase-Game
    chaseGameAddBackdrop: chaseGameAddBackdrop,
    chaseGameAddSprite1: chaseGameAddSprite1,
    chaseGameRightLeft: chaseGameRightLeft,
    chaseGameUpDown: chaseGameUpDown,
    chaseGameAddSprite2: chaseGameAddSprite2,
    chaseGameMoveRandomly: chaseGameMoveRandomly,
    chaseGamePlaySound: chaseGamePlaySound,
    chaseGameAddVariable: chaseGameAddVariable,
    chaseGameChangeScore: chaseGameChangeScore,

    // Make-A-Pop/Clicker Game
    popGamePickSprite: popGamePickSprite,
    popGamePlaySound: popGamePlaySound,
    popGameAddScore: popGameAddScore,
    popGameChangeScore: popGameChangeScore,
    popGameRandomPosition: popGameRandomPosition,
    popGameChangeColor: popGameChangeColor,
    popGameResetScore: popGameResetScore,

    // Animate A Character
    animateCharPickBackdrop: animateCharPickBackdrop,
    animateCharPickSprite: animateCharPickSprite,
    animateCharSaySomething: animateCharSaySomething,
    animateCharAddSound: animateCharAddSound,
    animateCharTalk: animateCharTalk,
    animateCharMove: animateCharMove,
    animateCharJump: animateCharJump,
    animateCharChangeColor: animateCharChangeColor,

    // Tell A Story
    storyPickBackdrop: storyPickBackdrop,
    storyPickSprite: storyPickSprite,
    storySaySomething: storySaySomething,
    storyPickSprite2: storyPickSprite2,
    storyFlip: storyFlip,
    storyConversation: storyConversation,
    storyPickBackdrop2: storyPickBackdrop2,
    storySwitchBackdrop: storySwitchBackdrop,
    storyHideCharacter: storyHideCharacter,
    storyShowCharacter: storyShowCharacter,

    // Video Sensing
    videoAddExtension: videoAddExtension,
    videoPet: videoPet,
    videoAnimate: videoAnimate,
    videoPop: videoPop,

    // Make it Fly
    flyChooseBackdrop: flyChooseBackdrop,
    flyChooseCharacter: flyChooseCharacter,
    flySaySomething: flySaySomething,
    flyMoveArrows: flyMoveArrows,
    flyChooseObject: flyChooseObject,
    flyFlyingObject: flyFlyingObject,
    flySelectFlyingSprite: flySelectFlyingSprite,
    flyAddScore: flyAddScore,
    flyKeepScore: flyKeepScore,
    flyAddScenery: flyAddScenery,
    flyMoveScenery: flyMoveScenery,
    flySwitchLooks: flySwitchLooks,

    // Pong
    pongAddBackdrop: pongAddBackdrop,
    pongAddBallSprite: pongAddBallSprite,
    pongBounceAround: pongBounceAround,
    pongAddPaddle: pongAddPaddle,
    pongMoveThePaddle: pongMoveThePaddle,
    pongSelectBallSprite: pongSelectBallSprite,
    pongAddMoreCodeToBall: pongAddMoreCodeToBall,
    pongAddAScore: pongAddAScore,
    pongChooseScoreFromMenu: pongChooseScoreFromMenu,
    pongInsertChangeScoreBlock: pongInsertChangeScoreBlock,
    pongResetScore: pongResetScore,
    pongAddLineSprite: pongAddLineSprite,
    pongGameOver: pongGameOver,

    // Imagine a World
    imagineTypeWhatYouWant: imagineTypeWhatYouWant,
    imagineClickGreenFlag: imagineClickGreenFlag,
    imagineChooseBackdrop: imagineChooseBackdrop,
    imagineChooseSprite: imagineChooseSprite,
    imagineFlyAround: imagineFlyAround,
    imagineChooseAnotherSprite: imagineChooseAnotherSprite,
    imagineLeftRight: imagineLeftRight,
    imagineUpDown: imagineUpDown,
    imagineChangeCostumes: imagineChangeCostumes,
    imagineGlideToPoint: imagineGlideToPoint,
    imagineGrowShrink: imagineGrowShrink,
    imagineChooseAnotherBackdrop: imagineChooseAnotherBackdrop,
    imagineSwitchBackdrops: imagineSwitchBackdrops,
    imagineRecordASound: imagineRecordASound,
    imagineChooseSound: imagineChooseSound,

    // Add a Backdrop
    addBackdrop: addBackdrop,

    // Add Effects
    addEffects: addEffects,

    // Hide and Show
    hideAndShow: hideAndShow,

    // Switch Costumes
    switchCostumes: switchCostumes,

    // Change Size
    changeSize: changeSize,

    // Spin
    spinTurn: spinTurn,
    spinPointInDirection: spinPointInDirection,

    // Record a Sound
    recordASoundSoundsTab: recordASoundSoundsTab,
    recordASoundClickRecord: recordASoundClickRecord,
    recordASoundPressRecordButton: recordASoundPressRecordButton,
    recordASoundChooseSound: recordASoundChooseSound,
    recordASoundPlayYourSound: recordASoundPlayYourSound,

    // Use Arrow Keys
    moveArrowKeysLeftRight: moveArrowKeysLeftRight,
    moveArrowKeysUpDown: moveArrowKeysUpDown,

    // Glide Around
    glideAroundBackAndForth: glideAroundBackAndForth,
    glideAroundPoint: glideAroundPoint,

    // Code a Cartoon
    codeCartoonSaySomething: codeCartoonSaySomething,
    codeCartoonAnimate: codeCartoonAnimate,
    codeCartoonSelectDifferentCharacter: codeCartoonSelectDifferentCharacter,
    codeCartoonUseMinusSign: codeCartoonUseMinusSign,
    codeCartoonGrowShrink: codeCartoonGrowShrink,
    codeCartoonSelectDifferentCharacter2: codeCartoonSelectDifferentCharacter2,
    codeCartoonJump: codeCartoonJump,
    codeCartoonChangeScenes: codeCartoonChangeScenes,
    codeCartoonGlideAround: codeCartoonGlideAround,
    codeCartoonChangeCostumes: codeCartoonChangeCostumes,
    codeCartoonChooseMoreCharacters: codeCartoonChooseMoreCharacters,

    // Talking Tales
    talesAddExtension: talesAddExtension,
    talesChooseSprite: talesChooseSprite,
    talesSaySomething: talesSaySomething,
    talesAskAnswer: talesAskAnswer,
    talesChooseBackdrop: talesChooseBackdrop,
    talesSwitchBackdrop: talesSwitchBackdrop,
    talesChooseAnotherSprite: talesChooseAnotherSprite,
    talesMoveAround: talesMoveAround,
    talesChooseAnotherBackdrop: talesChooseAnotherBackdrop,
    talesAnimateTalking: talesAnimateTalking,
    talesChooseThirdBackdrop: talesChooseThirdBackdrop,
    talesChooseSound: talesChooseSound,
    talesDanceMoves: talesDanceMoves
};

export {zhCnImages};
